export default __webpack_public_path__ + "static/docker-e0ba9d2386737b9f87c6e6888d548a2a.png";